import React, { useState, useEffect } from 'react';

export default ({ children, options: {name, userVisibleOnly = "", sysex = ""}, ...rest }) => {
  const request = {
    notifications: () => Notification.requestPermission(),
    geolocation: () => typeof navigator !== "undefined" && navigator.geolocation.getCurrentPosition(),
  };

  const [state, setPermission] = useState({
    state: "unknown"
  });

  const permissionEnum = [
    "geolocation",
    "notifications",
    "push",
    "midi",
    "camera",
    "microphone",
    "speaker",
    "device-info",
    "background-fetch",
    "background-sync",
    "bluetooth",
    "persistent-storage",
    "ambient-light-sensor",
    "accelerometer",
    "gyroscope",
    "magnetometer",
    "clipboard",
    "display-capture",
    "nfc"
  ];

  useEffect(() => {
    typeof navigator !== "undefined" && navigator.permissions.query({ name, userVisibleOnly, sysex }).then((result) => {
      const { state } = result;
      setPermission(state);
      const cb = () => {
        setPermission(result.state)
      }
      result.addEventListener('change', cb);
      return () => {
        result.removeEventListener('change', cb);
      }
    });
  }, [name, userVisibleOnly, sysex]);

  if(!permissionEnum.includes(name)) {
    return <span>Error: Permission {name} is invalid. The permission must be any of {permissionEnum.join(", ")}</span>
  }
  return (
    <>{children({
      state,
      request: (...args) => {
        setPermission("requested")
        return request[name](...args);
      },
      ...rest
    })}</>
  );
};
